import React, { useState } from "react";
import { Modal, Box } from "@mui/material";
import ZipCodeInfo from "./ZipCodeInfo";
import BusinessAddressForm from "./BusinessAddressForm";
import AssociatesList from "./AssociatesList";
import AssociateForm from "./AssociateForm";
import BusinessBankForm from "./BusinessBankForm";
import { useAppDispatch } from "../../../../hooks/hooks";
import { reset as AssociateReset } from "../../../../store/associateSlice";
import { reset as AddressReset } from "../../../../store/addressSlice";

interface SignUpModalProps {
  open: boolean;
  onClose: () => void;
}

const SignUpModal: React.FC<SignUpModalProps> = ({ open, onClose }) => {
  const handleNextStep = (step: string) => {
    setStep(step);
  };

  const handleBackStep = (step: string) => {
    setStep(step);
  };

  const dispatch = useAppDispatch();

  const closeIconClick = () => {
    setStep("zipCode");
    dispatch(AssociateReset());
    dispatch(AddressReset());
    onClose();
  };

  const modals: Record<string, any> = {
    zipCode: (
      <ZipCodeInfo handleNextStep={handleNextStep} close={closeIconClick} />
    ),
    businessAddress: (
      <BusinessAddressForm
        close={closeIconClick}
        handleNextStep={handleNextStep}
        handleBackStep={handleBackStep}
      />
    ),
    associatesList: (
      <AssociatesList
        close={closeIconClick}
        handleNextStep={handleNextStep}
        handleBackStep={handleBackStep}
      />
    ),
    businessBank: (
      <BusinessBankForm
        close={closeIconClick}
        handleBackStep={handleBackStep}
      />
    ),
    associateForm: (
      <AssociateForm
        close={closeIconClick}
        handleNextStep={handleNextStep}
        handleBackStep={handleBackStep}
      />
    ),
  };

  const [step, setStep] = useState<string>("zipCode");

  const getModalContent = () => {
    return modals[step];
  };

  return (
    <Modal open={open}>
      <Box
        sx={{
          borderRadius: "10px",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 668,
          bgcolor: "background.paper",
          boxShadow: 24,
        }}
      >
        {getModalContent()}
      </Box>
    </Modal>
  );
};

export default SignUpModal;
